<template>
    <div v-if="p != null">
        <div class="wine-shop-item__year" v-if="p.type == 'vini' && year != null">
            {{ year }}
        </div>
        <div class="wine-shop-item__year font-weight-normal no-letter-spacing pr-xl-4" v-else>
            <span v-html="shortenDescription"></span>
        </div>
        <div class="wine-shop-item__price price-style">
            <span>€</span>
            <span>
                {{ $root.currencyDisplaySimple(price) }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["product", "lang", "shorten"],
        data() {
            return {
                year: null,
                price: null,
                p: null,
                s: false,
            };
        },
        created() {
            this.p = this.product;

            if (typeof this.s != "undefined") {
                this.s = this.shorten;
            }

            let combinations = [];

            if (this.p.combinations.length > 0) {
                this.p.combinations.forEach((el) => {
                    if(el.attributes.length > 0) {
                        el.attributes.map(({ key, value }) => {
                            if(key == 'anno') {
                                combinations.push({year: value, price: el.price})
                            } else {
                                combinations.push({year: 0, price: el.price})
                            }
                        })
                    } else {
                        combinations.push({year: 0, price: el.price})
                    }
                });

                combinations.sort(function (a, b) {
                    return Number(b.year) - Number(a.year);
                });

                this.year = combinations[0].year;
                this.price = combinations[0].price;
            }
        },
        mounted() {},
        methods: {},
        computed: {
            shortenDescription() {
                let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

                if (vw >= 1200 && this.s) {
                    return this.p["subtitle_" + this.lang].substring(0, 55) + "...";
                }

                return this.p["subtitle_" + this.lang];
            },
        },
    };
</script>
